import { CROP_ACCENT_COLOR } from '../constants/crop-chrome'
import type { MoveBadgeLayout } from '../helpers/badge-layout'

const MOVE_ICON_PATH =
  'M3.33331 10L1.33331 8.00004L3.33331 6.00004M1.33331 8.00004H14.6666M9.99998 3.33337L7.99998 1.33337L5.99998 3.33337M7.99998 1.33337V14.6667M5.99998 12.6667L7.99998 14.6667L9.99998 12.6667M12.6666 10L14.6666 8.00004L12.6666 6.00004'

interface CropMoveBadgeProps {
  layout: MoveBadgeLayout
  /** Stroke width (canvas units). */
  sw: number
}

/** Center move badge — decorative only (see `computeMoveBadgeLayout`). */
export function CropMoveBadge({ layout, sw }: CropMoveBadgeProps) {
  return (
    <>
      <circle
        data-testid="crop-move-badge"
        cx={layout.centerX}
        cy={layout.centerY}
        r={layout.badgeR}
        fill="rgba(255, 255, 255, 0.6)"
        stroke={CROP_ACCENT_COLOR}
        strokeWidth={sw}
        vectorEffect="non-scaling-stroke"
        pointerEvents="none"
        style={{ filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.05))' }}
      />
      <g transform={layout.iconTransform} pointerEvents="none">
        <path
          d={MOVE_ICON_PATH}
          stroke={CROP_ACCENT_COLOR}
          strokeWidth={1.33}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </>
  )
}
